import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import './Password.scss';
import HrbTranslate from '../../language/HrbTranslate';
import RequirementItem from './RequirementItem';
import '../TextFormInputField.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const PasswordRequirements = (props) => {
    let { reqs, hasErrors, labelKey } = props;
    return (
        <div className={classNames('hrb-text-form-input-container', { "with-errors": hasErrors })}>
            <h3>
                {hasErrors &&
                    <FontAwesomeIcon icon={faExclamationCircle} />
                }
                <HrbTranslate text={labelKey} />
            </h3>
            <div className='hrb-text-form-input'>
                <div className="hrb-pw-reqs-container">
                    <RequirementItem name='new_password.upper_case_letter' isSatisfied={reqs.hasCapital} hasErrors={hasErrors} />
                    <RequirementItem name='new_password.lower_case_letter' isSatisfied={reqs.hasLower} hasErrors={hasErrors} />
                    <RequirementItem name='new_password.number' isSatisfied={reqs.hasNum} hasErrors={hasErrors} />
                    <RequirementItem name='new_password.special_character' isSatisfied={reqs.hasChars} hasErrors={hasErrors} />
                    <RequirementItem name='new_password.minimum_length' isSatisfied={reqs.hasLength} hasErrors={hasErrors} />
                </div>
            </div>
        </div>
    );
}

PasswordRequirements.propTypes = {
    reqs: PropTypes.shape({
        hasCapital: PropTypes.bool.isRequired
    }),
    labelKey: PropTypes.string.isRequired,
    hasErrors: PropTypes.bool.isRequired
};


export default PasswordRequirements;
